import { useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';

export function useMessages() {
  const { user } = useAuth();
  const userId = user?.id;
  const [messages, setMessages] = useState([]);

  const fetchMessages = useCallback(async (jobInterestId) => {
    if (!userId || !jobInterestId) return;
    const { data } = await supabase
      .from('messages')
      .select('*, sender:sender_id(display_name, photo_url)')
      .eq('job_interest_id', jobInterestId)
      .order('created_at', { ascending: true });
    if (data) setMessages(data);
  }, [userId]);

  async function sendMessage(recipientId, jobInterestId, content) {
    if (!user || !content.trim()) return { error: 'Invalid input' };
    const { data, error } = await supabase
      .from('messages')
      .insert({
        sender_id: user.id,
        recipient_id: recipientId,
        job_interest_id: jobInterestId,
        content: content.trim(),
      })
      .select('*, sender:sender_id(display_name, photo_url)')
      .single();
    if (!error && data) {
      setMessages(prev => [...prev, data]);
    }
    return { data, error };
  }

  return { messages, fetchMessages, sendMessage };
}
